import { render } from "./ModalNav.vue?vue&type=template&id=5960461b&scoped=true"
import script from "./ModalNav.vue?vue&type=script&lang=js"
export * from "./ModalNav.vue?vue&type=script&lang=js"

import "./ModalNav.vue?vue&type=style&index=0&id=5960461b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5960461b"]])

export default __exports__